import { CommandBar, SearchBox } from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';

const HeaderWithCommandBar = ({
  header,
  subHeadingText,
  showTitleFilter,
  setShowTitleFilter,
  titleFilterText,
  titleFilter,
  setTitleFilter,
  setShowGrid,
  showGrid,
  disableGrid,
}) => {
  const { t: translator } = useTranslation();

  const onSetTitleFilter = (_, value) => setTitleFilter(value);
  const onSetShowTitleFilter = () => setShowTitleFilter(!showTitleFilter);
  const onSetShowGrid = () => setShowGrid(!showGrid);

  const getFilterCommandBarItem = () => {
    return {
      key: 'showFilter',
      name:
        titleFilterText || translator('components.headerWithCommandBar.filter'),
      ariaDescription: translator('ariaLabel.pageHeaderToggleFilter'),
      iconProps: {
        iconName: 'Zoom',
      },
      disabled: false,
      buttonStyles: {
        root: {
          paddingRight: '50px',
          backgroundColor: '#FAFAFA',
        },
      },
      onClick: onSetShowTitleFilter,
    };
  };

  const getGridItems = () => {
    return {
      key: 'changeView',
      name: showGrid
        ? translator('components.headerWithCommandBar.listView')
        : translator('components.headerWithCommandBar.gridView'),
      ariaDescription: translator('ariaLabel.pageHeaderToggleView'),
      iconProps: {
        iconName: showGrid ? 'GroupedList' : 'GridViewSmall',
      },
      buttonStyles: {
        root: {
          backgroundColor: '#FAFAFA',
        },
      },
      onClick: onSetShowGrid,
    };
  };

  return (
    <div className="admin-page-container-header">
      <div className="admin-page-container-header-main">
        <h2 className="SFont p-style">{header}</h2>
        <div className="admin-page-container-header-right">
          {showTitleFilter ? (
            <SearchBox
              styles={{ root: { width: 200 } }}
              onChange={onSetTitleFilter}
              placeholder={
                titleFilterText ||
                translator('components.headerWithCommandBar.filter')
              }
              value={titleFilter}
              ariaLabel={translator('ariaLabel.pageHeaderSearch')}
            />
          ) : null}
          <CommandBar
            farItems={
              disableGrid
                ? [getFilterCommandBarItem()]
                : [getFilterCommandBarItem(), getGridItems()]
            }
            styles={{
              root: {
                Width: 'auto',
                backgroundColor: '#FAFAFA',
              },
            }}
            shiftOnReduce={false}
            className="admin-commandBar"
            ariaLabel={translator('ariaLabel.pageHeaderMenu')}
          />
        </div>
      </div>
      <div className="admin-page-container-header-sub">
        {subHeadingText && (
          <h4 className="SFont subheading-style">{subHeadingText}</h4>
        )}
      </div>
    </div>
  );
};

export { HeaderWithCommandBar };
